import { createRouter, createWebHistory } from 'vue-router'
import SignIn from './components/SignIn.vue'
import Home from './components/Home.vue'
import { UserManager, WebStorageStateStore } from 'oidc-client'
import axios from 'axios';

const userManager = new UserManager({
      authority: process.env.VUE_APP_IDENTITY_API,
      client_id: "geks-web",
      post_logout_redirect_uri: window.location.origin,
      redirect_uri: window.location.origin + "/callback",
      response_type: "code",
      scope: "openid offline_access",
      userStore: new WebStorageStateStore({
        store: window.localStorage
      })
    })

export default createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      component: Home
    },
    {
      path: '/signin',
      component: SignIn
    },
    {
      path: '/callback',
      name: 'callback',
      beforeEnter: async (to, from, next) => {
        try {
          // Обробка OIDC callback
          const user = await userManager.signinRedirectCallback()
          axios.defaults.headers.common['Authorization'] = "Bearer " + user.access_token
        } catch (error) {
          console.error('Помилка callback:', error)
        } finally {
          next('/')
        }
      }
    }
  ]
})

export { userManager }